/**
 * Minimale DOM-Helfer (kein Framework, keine Laufzeit-Abhaengigkeit).
 */

/** Element erzeugen mit Attributen, Styles und Kindern/Text. */
export function h(tag, attrs, children) {
  const el = document.createElement(tag);
  if (attrs) {
    for (const k in attrs) {
      if (attrs[k] == null) continue;
      if (k === "text") {
        el.textContent = attrs[k];
      } else if (k === "html") {
        el.innerHTML = attrs[k];
      } else {
        el.setAttribute(k, attrs[k]);
      }
    }
  }
  if (children) {
    for (const c of [].concat(children)) {
      if (c == null) continue;
      el.appendChild(typeof c === "string" ? document.createTextNode(c) : c);
    }
  }
  return el;
}

/** HTML-Escape (fuer Stellen, an denen wir ausnahmsweise innerHTML setzen). */
export function esc(s) {
  return String(s == null ? "" : s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

/** Fokussierbare Elemente innerhalb eines Containers (fuer Fokus-Trap). */
export function focusable(container) {
  return Array.prototype.slice.call(
    container.querySelectorAll(
      'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
    )
  ).filter((el) => el.offsetParent !== null || el.getClientRects().length > 0);
}
